import React, { useEffect, useState } from 'react';
import { alpha, experimentalStyled as styled } from '@mui/material/styles';
import { useLocation, useParams, Link as RouterLink, useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import {
  AppBar,
  Box,
  Button,
  CardContent,
  Card,
  Grid,
  Chip,
  CircularProgress
} from '@mui/material';
import Avatar from 'react-avatar';
import { capturePHEvents } from '../../analytics/posthog.analytics';
import ClassDetailModal from '../../components/ClassDetailModal';
import JoinClassModal from '../../components/JoinClassModal';
import { getTeacherDataAndClasses } from '../../service/enroll.service';
import { getCke } from '../../helper/cookieHelper';
import { getUserDetails } from '../../service/user.service';
import palette from '../../theme/palette';
import EmptyDashboard from '../../components/EmptyDashboard';
import { PH_CLASS_JOIN_CLICK } from '../../utils/posthog.eventNames';
// import DashboardNavbar from '../../layouts/dashboard/DashboardNavbar';
// import Page from '../../components/Page';

// const APP_BAR_MOBILE = 64;
// const APP_BAR_DESKTOP = 92;

// const RootStyle = styled(Page)(({ theme }) => ({
//   [theme.breakpoints.up('md')]: {
//     display: 'flex'
//   }
// }));

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

// const MainStyle = styled('div')(({ theme }) => ({
//   flexGrow: 1,
//   overflow: 'auto',
//   minHeight: '100%',
//   paddingTop: APP_BAR_MOBILE + 10,
//   paddingBottom: theme.spacing(10)
// }));

const NavbarRootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 50px',
  backgroundColor: alpha(theme.palette.background.default, 0.72)
}));

// const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
//   minHeight: APPBAR_MOBILE,
//   [theme.breakpoints.up('lg')]: {
//     minHeight: APPBAR_DESKTOP,
//     padding: theme.spacing(0, 5)
//   }
// }));

const useStyle = makeStyles({
  container: {
    paddingTop: '80px',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  avatarAndDetailsContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  userDescription: {
    marginLeft: 20
  },
  classCategory: {
    borderRadius: '4px',
    height: 'unset',
    padding: '4px 4px'
  },
  classListContainer: {
    marginTop: '20px'
  },
  classNameText: {
    marginTop: '10px'
  },
  classJoinButton: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  subjectNameAndType: {
    display: 'flex',
    alignItems: 'center'
  },
  subjectName: {
    color: palette.secondary.main,
    fontSize: '12px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginLeft: '10px'
  },
  subjectTag: {
    marginRight: '5px',
    background: palette.secondary.main,
    color: 'white',
    borderRadius: '4px',
    height: 'unset',
    fontWeight: 'bold'
  }
});

export default function EnrollPage() {
  const classes = useStyle();
  const [currentUser, setCurrentUser] = useState({});
  const [teacherDetails, setTeacherDetails] = useState({});
  const [teacherClasses, setTeacherClasses] = useState([]);
  const [openCLass, setOpenClass] = useState(false);
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [selectedClass, setSelectedData] = useState({});
  const [isDisplayJoinBtn, setDisplayJoinBtn] = useState(true);
  const [showClassDetails, setShowClassDetails] = useState(false);

  useEffect(() => {
    async function getUser() {
      const loggedUserId = getCke('userId');
      if (loggedUserId) {
        const userRes = await getUserDetails(loggedUserId);
        if (userRes) {
          setCurrentUser(userRes.user);
          setDisplayJoinBtn(userRes.user.profile === 'student');
        }
      }
    }
    getUser();
  }, []);

  useEffect(() => {
    if (location.search.includes('isJoinClass') && Object.keys(currentUser).length) {
      const classId = location.search.split('=')[1];
      const classDetails = teacherClasses.filter((tc) => tc.classId._id === classId);
      setSelectedData(classDetails.length ? classDetails[0] : {});
    }
  }, [location, currentUser, teacherClasses]);

  useEffect(() => {
    if (location.search.includes('isJoinClass') && Object.keys(selectedClass).length) {
      if (currentUser.profile === 'student') {
        setOpenClass(true);
      }
    }
  }, [location, selectedClass]);

  useEffect(() => {
    async function getTechData() {
      const res = await getTeacherDataAndClasses(params.id);
      if (res?.statusCode === 400) {
        setError(true);
        setLoading(false);
      } else if (res) {
        setTeacherClasses(res.classes);
        setTeacherDetails(res.userDetails);
        setLoading(false);
      } else {
        setError(true);
        setLoading(false);
      }
    }
    getTechData();
  }, [params]);

  return (
    <RootStyle
      title="Fainlearn | Enroll"
      isDivRender={false}
      style={{
        display: `${isError || loading ? 'flex' : ''}`,
        width: `${isError || loading ? '100%' : ''}`,
        height: `${isError || loading ? '100%' : ''}`,
        justifyContent: `${isError || loading ? 'center' : ''}`,
        alignItems: `${isError || loading ? 'center' : ''}`
      }}
    >
      {loading && <CircularProgress />}
      {!loading && isError && (
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          <EmptyDashboard text="No instructor found" />
          <Button component={RouterLink} to="/dashboard/app" sx={{ marginTop: '10px' }}>
            Go to dashboard
          </Button>
        </div>
      )}
      {!loading && !isError && (
        <div className={classes.container}>
          <NavbarRootStyle>
            <Box
              onClick={() => navigate('/')}
              component="img"
              src="/static/logo-new.svg"
              sx={{ height: '100px' }}
            />
            <Box sx={{ flexGrow: 1 }} />
            {Object.keys(currentUser).length > 0 ? (
              <Avatar src={currentUser.profileImage} name={currentUser.fullName} round size={45} />
            ) : (
              <Button
                onClick={() => {
                  window.localStorage.setItem('fromEnroll', location.pathname);
                  setTimeout(() => {
                    navigate('/login', { replace: true });
                  }, 1000);
                }}
                variant="contained"
                style={{ height: 'fit-content' }}
              >
                Login
              </Button>
            )}
          </NavbarRootStyle>
          <div className={classes.container}>
            <Card>
              <CardContent>
                <div className={classes.avatarAndDetailsContainer}>
                  <Avatar src={teacherDetails.profileImage} name={teacherDetails.fullName} round />
                  <div className={classes.userDescription}>
                    <h2>{teacherDetails.fullName}</h2>
                    {teacherClasses.map((tc) => (
                      <Chip
                        className={classes.subjectTag}
                        key={tc?.classId?._id}
                        label={tc?.classId?.subject}
                      />
                    ))}
                    <p>Teacher descriptions</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <div className={classes.classListContainer}>
              <Grid
                container
                spacing={2}
                direction="row"
                justify="flex-start"
                alignItems="flex-start"
              >
                {teacherClasses.map((tc) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    key={tc?.classId?._id}
                    style={{ cursor: 'pointer' }}
                  >
                    <Card
                      onClick={() => {
                        setSelectedData(tc);
                        setShowClassDetails(true);
                      }}
                    >
                      <img
                        src={tc?.classId?.bannerUrl ?? ''}
                        style={{ width: '100%', height: 'auto' }}
                        alt={`${tc?.classId.name} - banner`}
                      />
                      <CardContent>
                        <div className={classes.subjectNameAndType}>
                          <Chip
                            className={classes.classCategory}
                            label={tc?.classId?.type.toUpperCase()}
                          />
                          <div className={classes.subjectName}>{tc?.classId?.subject}</div>
                        </div>
                        <div className={classes.classNameText}>{tc?.classId?.name}</div>
                        {isDisplayJoinBtn && (
                          <div className={classes.classJoinButton}>
                            <Button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setOpenClass(true);
                                capturePHEvents(PH_CLASS_JOIN_CLICK, { tc });
                                setSelectedData(tc);
                              }}
                            >
                              Join Class
                            </Button>
                          </div>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
        </div>
      )}
      <JoinClassModal
        isOpen={openCLass}
        handleClosePopup={() => {
          setSelectedData({});
          setOpenClass(false);
        }}
        classData={selectedClass}
        currentUser={currentUser}
      />
      {showClassDetails && (
        <ClassDetailModal
          isOpen={showClassDetails}
          handleClose={() => {
            setShowClassDetails(false);
            setSelectedData({});
          }}
          classDetails={selectedClass}
        />
      )}
    </RootStyle>
  );
}
